import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { getPublicAssetUrl } from "@/lib/utils"

import type { User } from "@boundless/bl-api-client/common/models"

export function AvatarBadge({ user }: { user: User }) {
  return (
    <Avatar className="h-12 w-12 rounded-lg">
      <AvatarImage
        src={getPublicAssetUrl("/avatar.png")}
        alt={user.firstName}
        className="rounded-lg object-cover"
      />
      <AvatarFallback className="rounded-lg bg-gray-100">
        {(user.firstName || "")
          .split(" ")
          .map((n) => n[0])
          .join("")}
      </AvatarFallback>
    </Avatar>
  )
}
